var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.datas),function(data){return _c('blocTypeUser',{key:data.id,attrs:{"titre":data.nom,"template":!!data.template,"data-id":data.id,"linkOnly":true,"blocLink":'/mes-tableaux/' + data.id},on:{"editProject":_vm.handleEditProject,"deleteProject":_vm.handleDeleteProject}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6638b8e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/listProjet/index.vue
// module id = null
// module chunks = 